module.exports = __webpack_public_path__ + "static/media/trestles.e8e05ed2.png";